function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open")
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  async onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    this.toggleLoadingEffect(event.currentTarget, true);

    event.currentTarget.name === "plus"
      ? this.input.stepUp()
      : this.input.stepDown();
    if (previousValue !== this.input.value) {
      await new Promise((resolve) => setTimeout(resolve, 1000));
      this.input.dispatchEvent(this.changeEvent);
    }

    this.toggleLoadingEffect(event.currentTarget, false);
  }

  toggleLoadingEffect(targetButton, isLoading) {
    if (targetButton && typeof targetButton.closest === "function") {
      const lineItemContainer = targetButton.closest(".line-item-container");
      if (lineItemContainer) {
        lineItemContainer.classList.toggle("loading", isLoading);
      }
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle("disabled", value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  attachCloseIconListener() {
    const closeIconWrapper = this.querySelector(".menu-drawer-close-wrapper");
    if (closeIconWrapper) {
      closeIconWrapper.addEventListener("click", () => {
        this.closeMenuDrawer();
      });
    }
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    // this.querySelectorAll("button").forEach((button) =>
    //   button.addEventListener("click", this.onCloseButtonClick.bind(this))
    // );
    // this.querySelector(".menu-drawer-close-icon").parentNode.addEventListener("click", () => {
    //   this.closeMenuDrawer();
    // });
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 1024px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    const currentYscroll = window.scrollY;
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    document.body.style.setProperty("position", "fixed", "important");
    document.body.style.top = `-${currentYscroll}px`;
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;
    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    const scrollY = document.body.style.top;
    document.body.style.position = "";
    document.body.style.top = "";
    window.scrollTo(0, parseInt(scrollY || "0") * -1);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  // onCloseButtonClick(event) {
  //   const detailsElement = event.currentTarget.closest('details');
  //   this.closeSubmenu(detailsElement);
  // }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
    this.attachOverlayListener();
    this.attachPageShowListener();
  }

  attachPageShowListener() {
    window.addEventListener('pageshow', (event) => {
      if (event.persisted) {
        const menuDrawerContainer = document.querySelector("#Details-menu-drawer-container");
        if (menuDrawerContainer && menuDrawerContainer.hasAttribute("open")) {
          const summary = menuDrawerContainer.querySelector("summary");
          const fakeEvent = new Event("click");
          this.closeMenuDrawer(fakeEvent, summary);
        }
      }
    });
  }

  attachOverlayListener() {
    const menuDrawerContainer = document.querySelector("#Details-menu-drawer-container");
    if (menuDrawerContainer) {
      menuDrawerContainer.addEventListener("click", (e) => {
        if (e.target === menuDrawerContainer && menuDrawerContainer.hasAttribute("open")) {
          e.preventDefault();
          e.stopPropagation();
          
          const summary = menuDrawerContainer.querySelector("summary");
          const fakeEvent = new Event("click");
          this.closeMenuDrawer(fakeEvent, summary);
        }
      });
    }
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector(".section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    const currentYscroll = window.scrollY;
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    
    document.documentElement.style.overflow = 'hidden';
    document.documentElement.style.height = '100%';
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    document.body.style.top = `-${currentYscroll}px`;
    document.body.style.width = '100%';
    document.body.style.overflowY = 'scroll';
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    
    // Restore scroll position
    const scrollY = document.body.style.top;
    document.documentElement.style.overflow = '';
    document.documentElement.style.height = '';
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.width = '';
    document.body.style.overflowY = '';
    window.scrollTo(0, parseInt(scrollY || "0") * -1);
    
    this.header.classList.remove("menu-open");
    if (showFullBleedHero && window.location.pathname === "/") {
      handleFullBleedHeroSlider("onDrawerClose");
    }
  }
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));

    if (this.nextButton && this.prevButton) {
      this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
      this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
    }

    const variantSwatches = document.querySelectorAll(".variant-swatch");
    variantSwatches.forEach((swatch) =>
      swatch.addEventListener("click", this.selectVariant.bind(this))
    );
  }

  selectVariant(event) {
    const selectedVariantImageUrl = event.target.src.split("&width=")[0];

    let productImagesSelection =
      document.body.querySelectorAll("#product-images p");
    let productImageContainer = document.body.querySelector("#product-images");

    const imageSelectedIndex = Array.from(productImagesSelection);

    imageSelectedIndex.forEach((e, index) => {
      if (e.textContent === selectedVariantImageUrl) {
        productImageContainer.setAttribute("data-selected-slide", `${index}`);
      }
    });
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener(
      "click",
      this.autoPlayToggle.bind(this)
    );
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active"
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
          this.slider.querySelector(".slideshow__slide").clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a");
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute("tabindex");
          });
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute("tabindex", "-1");
          });
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.hasKlaviyo = this.getAttribute("data-has-klaviyo") === "true";
    this.addEventListener("change", this.onVariantChange);
  }
  updateWishListButton() {
    const wishListContainer = document.getElementById(
      `wishList-${this.dataset.section}`
    );

    if (!wishListContainer) return;

    const wishListBtn =
      wishListContainer.getElementsByClassName("iWishAddColl")[0];
    var wishList = isInWishlist(
      String(this.currentVariant.featured_image.product_id),
      String(this.currentVariant.id)
    );
    wishListBtn.classList.toggle("iwishAdded", wishList);
    wishListBtn.dataset.variant = this.currentVariant.id;
  }
  onVariantChange(event) {
    if (event.target.classList.contains("size-select")) return;
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      // this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      // showCurrentMedia(this.currentVariant.id);
    }

    this.updateWishListButton();
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(
      `[id^="MediaGallery-${this.dataset.section}"]`
    );
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        false
      )
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      let availableOptionInputsValue;
      if (!this.hasKlaviyo) {
        availableOptionInputsValue = selectedOptionOneVariants
          .filter(
            (variant) =>
              variant.available &&
              variant[`option${index}`] === previousOptionSelected
          )
          .map((variantOption) => variantOption[`option${index + 1}`]);
      } else {
        availableOptionInputsValue = selectedOptionOneVariants
          .filter(
            (variant) => variant[`option${index}`] === previousOptionSelected
          )
          .map((variantOption) => variantOption[`option${index + 1}`]);
      }
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.innerText = input.getAttribute("value");
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace(
          "[value]",
          input.getAttribute("value")
        );
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;
    const destination = document.getElementById(
      `price-${this.dataset.section}`
    );
    destination.classList.add("loading");
    const productGalleryImages = document.querySelector(
      ".product-gallery-list"
    );
    const priceInBtn = document.querySelector(".price-in-btn");
    const pdpDescription = document.querySelector(
      ".product-accordion-info-content.description"
    );

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");

        if (productGalleryImages) {
          // aqui
          productGalleryImages.innerHTML = html.querySelector(
            ".product-gallery-list"
          ).innerHTML;

          document
            .querySelectorAll(".product-gallery-desktop .img-zoom-container")
            .forEach(function (item) {
              if (window.imageZoom) {
                window.imageZoom(item);
              }
            });
        }

        if (priceInBtn) {
          priceInBtn.innerHTML = html.querySelector(".price-in-btn").innerHTML;
        }

        if (pdpDescription) {
          pdpDescription.innerHTML = html.querySelector(
            ".product-accordion-info-content.description"
          ).innerHTML;
        }

        const destination = document.getElementById(
          `price-${this.dataset.section}`
        );
        destination.classList.remove("loading");
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuSource = html.getElementById(
          `Sku-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuDestination = document.getElementById(
          `Sku-${this.dataset.section}`
        );
        const barcodeSource = html.getElementById(
          `Barcode-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const barcodeDestination = document.getElementById(
          `Barcode-${this.dataset.section}`
        );
        const inventorySource = html.getElementById(
          `Inventory-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const inventoryDestination = document.getElementById(
          `Inventory-${this.dataset.section}`
        );

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle(
            "visibility-hidden",
            skuSource.classList.contains("visibility-hidden")
          );
        }
        if (barcodeSource && barcodeDestination) {
          barcodeDestination.innerHTML = barcodeSource.innerHTML;
          barcodeDestination.classList.toggle(
            "visibility-hidden",
            barcodeSource.classList.contains("visibility-hidden")
          );
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("visibility-hidden");

        if (inventoryDestination)
          inventoryDestination.classList.toggle(
            "visibility-hidden",
            inventorySource.innerText === ""
          );

        const addButtonUpdated = html.getElementById(
          `ProductSubmitButton-${sectionId}`
        );
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;

    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    const dynamicCheckoutButton = productForm.querySelector(
      ".dynamic-checkout-buttons"
    );

    if (!addButton) return;

    if (disable) {
      if (this.hasKlaviyo) {
        addButton.classList.add("hidden");
        if (dynamicCheckoutButton) {
          dynamicCheckoutButton.classList.add("hidden");
        }
      } else {
        addButton.setAttribute("disabled", "disabled");
      }
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      // Re-enable and show the add to cart button and dynamic checkout button
      if (this.hasKlaviyo) {
        addButton.classList.remove("hidden");
        if (dynamicCheckoutButton) {
          dynamicCheckoutButton.classList.remove("hidden");
        }
      }
      addButtonText.textContent = window.variantStrings.addToCart;
    }
    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const barcode = document.getElementById(`Barcode-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
    if (inventory) inventory.classList.add("visibility-hidden");
    if (sku) sku.classList.add("visibility-hidden");
    if (barcode) barcode.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  checkNewInput(input) {
    input.checked = true;
    this.updateOptions();
    this.updateMasterId();

    // Ensure we have a current variant before rendering product info
    if (this.currentVariant) {
      this.renderProductInfo();
    }
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    let checkedInput = listOfOptions.find((input) => input.checked);

    // Get the list of enabled options
    const enabledOptions = listOfOptions.filter((input) =>
      listOfAvailableOptions.includes(input.getAttribute("value"))
    );

    enabledOptions.forEach((input) => {
      input.classList.remove("disabled");
      input.removeAttribute("disabled");
    });

    listOfOptions.forEach((input) => {
      if (
        !listOfAvailableOptions.includes(input.getAttribute("value")) &&
        !input.classList.contains("sizeguide-select-option")
      ) {
        input.classList.add("disabled");
        input.setAttribute("disabled", "disabled");
      }
    });

    // If the current checked option is not enabled, select the first enabled one
    if (checkedInput && checkedInput.classList.contains("disabled")) {
      this.checkNewInput(enabledOptions[0]);
      checkedInput = enabledOptions[0];
    }
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
    this.fetchRecommendation();
  }

  fetchRecommendation() {
    const recommendationSlider = document.querySelector(
      '[id^="slider-template--"]'
    );
    if (!recommendationSlider) {
      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          let recommendations = html.querySelector("product-recommendations");

          if (this.id) {
            recommendations = html.querySelector(
              "product-recommendations#" + this.id
            );
          }

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (
            !this.querySelector("slideshow-component") &&
            this.classList.contains("complementary-products")
          ) {
            this.remove();
          }

          this.classList.add("product-recommendations--loaded");

          if (typeof iwishCheckColl === "function") iwishCheckColl();
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }
}

customElements.define("product-recommendations", ProductRecommendations);


class NewDetailsDrawerController {
  constructor() {
    this.bindEvents();
  }

  bindEvents() {
    document.addEventListener('click', (event) => {
      if (event.target.classList.contains('quick-view__btn')) {
        this.openDrawer(event);
      }
    });
  }

  openDrawer(event) {
    event.preventDefault();
    
    const button = event.target;
    const container = button.closest('.quick-view__container');
    const dialog = container.querySelector('dialog');

    if (dialog) {
      const originalParent = dialog.parentNode;

      if (originalParent !== document.body) {
        document.body.appendChild(dialog);
        dialog._movedFrom = originalParent;
      }

      dialog.showModal();
      dialog.classList.add('flex');
      
      document.documentElement.classList.add('overflow-hidden');

      this.initializeDrawerFunctionality(dialog);

      const handleKeydown = (e) => {
        if (e.key === 'Escape') {
          this.closeDrawer(dialog);
          dialog.classList.remove('flex');
          document.removeEventListener('keydown', handleKeydown);
        }
      };
      document.addEventListener('keydown', handleKeydown);
      
      const handleClick = (e) => {
        if (e.target === dialog) {
          this.closeDrawer(dialog);
          dialog.classList.remove('flex');
          dialog.removeEventListener('click', handleClick);
        }
      };
      dialog.addEventListener('click', handleClick);
      
      const closeButton = dialog.querySelector('.close-details-drawer');
      if (closeButton) {
        const handleCloseClick = () => {
          this.closeDrawer(dialog);
          dialog.classList.remove('flex');
          closeButton.removeEventListener('click', handleCloseClick);
        };
        closeButton.addEventListener('click', handleCloseClick);
      }
    }
  }

  initializeDrawerFunctionality(dialog) {
    const productDataElement = dialog.querySelector('[id^="product-data-"]');
    if (!productDataElement) return;
    
    const productData = JSON.parse(productDataElement.textContent);
    const productId = productData.id;
    
    this.preloadSwatchImages(dialog);
    this.initializeAddToCart(dialog, productId);
    
    this.initializeDefaultSelections(dialog, productData, productId);
    
    const colorSwatches = dialog.querySelectorAll('.color-swatch');
    colorSwatches.forEach(swatch => {
      swatch.addEventListener('click', (e) => {
        e.preventDefault();
        
        if (swatch.classList.contains('unavailable')) {
          return; 
        }
        
        const productId = swatch.dataset.productId;
        const productUrl = swatch.dataset.productUrl;
        
        if (productId && productUrl) {
          this.switchToProduct(dialog, productUrl, swatch);
          return;
        }
        
        colorSwatches.forEach(s => s.classList.remove('selected'));
        swatch.classList.add('selected');
        
        const colorName = swatch.dataset.optionValue;
        const colorNameDisplay = dialog.querySelector(`#drawer-color-name-${productId}`);
        if (colorNameDisplay) {
          colorNameDisplay.textContent = colorName;
        }
        
        const img = swatch.querySelector('img');
        if (img) {
          const mainImage = dialog.querySelector('[id^="main-product-image-"]');
          if (mainImage) {
            this.updateDrawerImage(mainImage, img.src);
          }
        }
        
        this.updateSizeButtonsForColor(dialog, productData, colorName, productId);
      });
    });
    
    const sizeButtons = dialog.querySelectorAll('.size-button');
    sizeButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        
        if (button.classList.contains('unavailable')) return;
        
        const allSizeButtons = dialog.querySelectorAll('.size-button');
        allSizeButtons.forEach(b => b.classList.remove('selected'));
        
        button.classList.add('selected');
        
        this.updatePrice(dialog, button.dataset.variantPrice, button.dataset.variantComparePrice, productId);
      });
    });
  }

  initializeDefaultSelections(dialog, productData) {
    const currentColor = productData.variants[0]?.option1;
    if (!currentColor) return;

    const colorSwatches = dialog.querySelectorAll('.color-swatch');
    
    let currentProductSwatch = Array.from(colorSwatches).find(swatch => 
      swatch.dataset.optionValue === currentColor && 
      swatch.dataset.productId === productData.id.toString()
    );

    if (!currentProductSwatch) {
      currentProductSwatch = Array.from(colorSwatches).find(swatch => 
        swatch.dataset.optionValue === currentColor
      );
    }

    if (!currentProductSwatch && colorSwatches.length > 0) {
      currentProductSwatch = colorSwatches[0];
    }

    if (currentProductSwatch) {
      colorSwatches.forEach(s => s.classList.remove('selected'));
      currentProductSwatch.classList.add('selected');
      
      const colorNameDisplay = dialog.querySelector('.drawer-color-name');
      if (colorNameDisplay) {
        colorNameDisplay.textContent = currentProductSwatch.dataset.optionValue || currentColor;
      }
    }

    const preSelectedSize = dialog.querySelector('.size-button.selected');
    if (preSelectedSize) {
      this.updatePrice(dialog, preSelectedSize.dataset.variantPrice, preSelectedSize.dataset.variantComparePrice);
    } else {
      const sizeButtons = dialog.querySelectorAll('.size-button');
      const firstAvailableSize = Array.from(sizeButtons).find(button => 
        !button.classList.contains('unavailable')
      );

      if (firstAvailableSize) {
        sizeButtons.forEach(b => b.classList.remove('selected'));
        firstAvailableSize.classList.add('selected');
        
        this.updatePrice(dialog, firstAvailableSize.dataset.variantPrice, firstAvailableSize.dataset.variantComparePrice);
      }
    }
  }

  updateSizeButtonsForColor(dialog, productData, selectedColor) {
    const sizeButtons = dialog.querySelectorAll('.size-button');
    
    sizeButtons.forEach(button => {
      button.classList.remove('selected', 'unavailable');
      button.style.display = 'flex';
    });
    
    const colorVariants = productData.variants.filter(variant => 
      variant.option1 === selectedColor
    );
    
    let firstAvailableButton = null;
    
    sizeButtons.forEach(button => {
      const sizeValue = button.dataset.optionValue;
      const variant = colorVariants.find(v => v.option2 === sizeValue);
      
      if (variant) {
        button.dataset.variantId = variant.id.toString().split('/').pop();
        button.dataset.variantPrice = variant.price;
        button.dataset.variantComparePrice = variant.compare_at_price;
        
        if (!variant.available) {
          button.classList.add('unavailable');
        } else if (!firstAvailableButton) {
          firstAvailableButton = button;
        }
      } else {
        button.style.display = 'none';
      }
    });
    
    if (firstAvailableButton) {
      firstAvailableButton.classList.add('selected');
      this.updatePrice(dialog, firstAvailableButton.dataset.variantPrice, firstAvailableButton.dataset.variantComparePrice);
    }
  }

  updatePrice(dialog, price, comparePrice) {
    const priceDisplay = dialog.querySelector('.drawer-product-price');
    if (priceDisplay) {
      const numPrice = parseFloat(price);
      const numComparePrice = parseFloat(comparePrice);
      
      if (isNaN(numPrice)) {
        console.error('Invalid price value:', price);
        priceDisplay.innerHTML = 'Price unavailable';
        return;
      }
      
      const formattedPrice = (numPrice / 100).toFixed(2);
      
      if (!isNaN(numComparePrice) && numComparePrice > numPrice && numComparePrice > 0) {
        const formattedComparePrice = (numComparePrice / 100).toFixed(2);
        priceDisplay.innerHTML = `<span class="text-highlight-primary-50">$${formattedPrice}</span><span class="text-text-color line-through font-normal ml-2">$${formattedComparePrice}</span>`;
      } else {
        priceDisplay.innerHTML = `$${formattedPrice}`;
      }
    }
  }

  switchToProduct(dialog, productUrl, clickedSwatch) {
    const addToCartButton = dialog.querySelector('.drawer-add-to-cart-inner');
    addToCartButton.textContent = 'Loading...';
    addToCartButton.disabled = true;
    addToCartButton.classList.add('opacity-60');

    const cleanUrl = cleanProductUrl(productUrl);

    fetch(cleanUrl + '.js')
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(productData => {
        const titleElement = dialog.querySelector('.body-small.font-semibold');
        if (titleElement) {
          titleElement.textContent = productData.title;
        }

        const seeDetailsLink = dialog.querySelector('a[href*="/products/"]');
        if (seeDetailsLink) {
          seeDetailsLink.href = cleanUrl;
        }

        const mainImage = dialog.querySelector('[id^="main-product-image-"]');
        const clickedImage = clickedSwatch.querySelector('img');
        if (mainImage && clickedImage) {
          this.updateDrawerImage(mainImage, clickedImage.src);
        } else if (mainImage && productData.featured_image) {
          this.updateDrawerImage(mainImage, productData.featured_image);
        }

        const colorNameDisplay = dialog.querySelector('.drawer-color-name');
        if (colorNameDisplay) {
          colorNameDisplay.textContent = clickedSwatch.dataset.optionValue;
        }

        const colorSwatches = dialog.querySelectorAll('.color-swatch');
        colorSwatches.forEach(s => s.classList.remove('selected'));
        clickedSwatch.classList.add('selected');

        this.updateSizeButtonsForNewProduct(dialog, productData);

        addToCartButton.textContent = 'Add To Cart';
        addToCartButton.disabled = false;
        addToCartButton.classList.remove('opacity-60');

      })
      .catch(error => {
        console.error('Error fetching product data:', error);
        
        if (error.message.includes('Unexpected token')) {
          console.warn('Product URL returned HTML instead of JSON. This might be a 404 or invalid product URL:', cleanUrl);
        } else if (error.message.includes('HTTP error')) {
          console.warn('HTTP error when fetching product data:', cleanUrl);
        }
        
        addToCartButton.textContent = 'Add To Cart';
        addToCartButton.disabled = false;
        addToCartButton.classList.remove('opacity-60');
      });
  }

  updateSizeButtonsForNewProduct(dialog, productData) {
    const sizeButtons = dialog.querySelectorAll('.size-button');
    
    sizeButtons.forEach(button => button.remove());

    const sizeOption = productData.options.find(option => 
      option.name.toLowerCase() === 'size' || option.position === 2
    );

    if (sizeOption && sizeOption.values) {
      const sizeContainer = dialog.querySelector('.drawer-size-buttons');
      
      sizeOption.values.forEach((sizeValue) => {
        const variant = productData.variants.find(v => v.option2 === sizeValue);
        if (variant) {
          const sizeButton = document.createElement('div');
          sizeButton.className = `size-button ${!variant.available ? 'unavailable' : ''}`;
          sizeButton.textContent = sizeValue;
          sizeButton.dataset.optionValue = sizeValue;
          sizeButton.dataset.variantId = variant.id.toString().split('/').pop();
          sizeButton.dataset.variantPrice = variant.price;
          sizeButton.dataset.variantComparePrice = variant.compare_at_price;
          
          sizeButton.addEventListener('click', (e) => {
            e.preventDefault();
            
            if (sizeButton.classList.contains('unavailable')) return;
            
            const allSizeButtons = sizeContainer.querySelectorAll('.size-button');
            allSizeButtons.forEach(b => b.classList.remove('selected'));
            
            sizeButton.classList.add('selected');
            
            this.updatePrice(dialog, variant.price, variant.compare_at_price);
          });

          sizeContainer.appendChild(sizeButton);
        }
      });

      const firstAvailableSize = Array.from(sizeContainer.querySelectorAll('.size-button')).find(button => 
        !button.classList.contains('unavailable')
      );

      if (firstAvailableSize) {
        firstAvailableSize.classList.add('selected');
        this.updatePrice(dialog, firstAvailableSize.dataset.variantPrice, firstAvailableSize.dataset.variantComparePrice);
      }
    }
  }

  preloadSwatchImages(dialog) {
    const isDesktop = typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(min-width: 640px)').matches;
    if (!isDesktop) return;

    const colorSwatches = dialog.querySelectorAll('.color-swatch img');
    colorSwatches.forEach(img => {
      if (img.src) {
        const preloadImg = new Image();
        const largeImageSrc = img.src.replace(/width=\d+/, 'width=360').replace(/height=\d+/, 'height=360');
        preloadImg.src = largeImageSrc;
      }
    });
  }

  initializeAddToCart(dialog) {
    const addToCartButton = dialog.querySelector('.drawer-add-to-cart-inner');
    if (addToCartButton) {
      addToCartButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.addToCart(dialog);
      });
    }
  }

  addToCart(dialog) {
    const addToCartButton = dialog.querySelector('.drawer-add-to-cart-inner');
    const originalButtonText = addToCartButton.textContent;
    
    addToCartButton.textContent = 'Adding...';
    addToCartButton.disabled = true;
    addToCartButton.classList.add('opacity-60');

    const selectedSizeButton = dialog.querySelector('.size-button.selected');
    if (!selectedSizeButton) {
      alert('Please select a size');
      this.resetAddToCartButton(addToCartButton, originalButtonText);
      return;
    }

    const variantId = selectedSizeButton.dataset.variantId;
    const quantity = 1;
    const isFinalSale = this.getIsFinalSaleProduct(dialog);
    
    const body = {
      items: [
        {
          id: variantId,
          quantity: quantity,
        },
      ],
    };

    if (isFinalSale) {
      body.items[0].properties = {
        ['Product Tag']: 'final_sale'
      };
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-hava-alpa': 'BF26981CA6970831906363B2BEAF1AFB0E469D90454E180ADA12802A012A0E72',
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        this.openCartDrawer(dialog);
        this.resetAddToCartButton(addToCartButton, originalButtonText);
      })
      .catch((error) => {
        console.error('Error:', error);
        alert('Error adding product to cart. Please try again.');
        this.resetAddToCartButton(addToCartButton, originalButtonText);
      });
  }

  resetAddToCartButton(button, originalText) {
    button.textContent = originalText;
    button.disabled = false;
    button.classList.remove('opacity-60');
  }

  getIsFinalSaleProduct(dialog) {
    const tagsContainer = dialog.querySelector('.drawer-product-tags');
    return tagsContainer && tagsContainer.querySelector('#final_sale_tag') != null;
  }

  openCartDrawer(dialog) {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) {
      console.error('Cart drawer element not found');
      return;
    }
    
    fetch('/cart.js')
      .then((response) => response.json())
      .then((cartData) => {
        const isCartEmpty = cartData.item_count === 0;
        return fetch(`${window.location.origin}?section_id=cart-drawer`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const previousCartDrawerElement = document.querySelector('#CartDrawer');
            
            if (isCartEmpty) {
              const emptyStateElement = document.querySelector('.drawer.is-empty');
              if (emptyStateElement) {
                previousCartDrawerElement.innerHTML = emptyStateElement.outerHTML;
                previousCartDrawerElement.classList.remove('is-empty');
              } else {
                console.error('Empty state element not found in cart drawer HTML');
              }
            } else {
              const newCartDrawerElement = html.querySelector('#CartDrawer');
              if (newCartDrawerElement) {
                previousCartDrawerElement.innerHTML = newCartDrawerElement.outerHTML;
                const cartDrawerContainer = document.querySelector('.drawer');
                cartDrawerContainer.classList.remove('is-empty');
              } else {
                console.error('Cart items element not found in cart drawer HTML');
              }
            }

            cartDrawer.open();
            this.updateCartIconBubble();
            this.closeDrawer(dialog);
          });
      })
      .catch((error) => {
        console.error('Error updating cart drawer:', error);
      });
  }

  updateCartIconBubble() {
    fetch(`${window.location.origin}?section_id=cart-icon-bubble`)
      .then((response) => response.text())
      .then((responseText) => {
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.getSectionInnerHTML === 'function') {
          const cartIconBubbleHTML = cartDrawer.getSectionInnerHTML(responseText, '.shopify-section');
          document.getElementById('cart-icon-bubble').innerHTML = cartIconBubbleHTML;
        } else {
          console.error('CartDrawer class or getSectionInnerHTML method not found');
        }
      })
      .catch((error) => {
        console.error('Error updating cart icon bubble:', error);
      });
  }

  closeDrawer(dialog) {
    dialog.close();
    dialog.classList.remove('flex');
    document.documentElement.classList.remove('overflow-hidden');

    if (dialog._movedFrom) {
      dialog._movedFrom.appendChild(dialog);
      delete dialog._movedFrom;
    }
  }

  updateDrawerImage(mainImage, imageSrc) {
    if (!mainImage || !imageSrc) return;
    
    const urlParts = imageSrc.split('?');
    const baseUrl = urlParts[0];
    const existingParams = urlParts[1] || '';
    
    const urlParams = new URLSearchParams(existingParams);
    urlParams.delete('width');
    urlParams.delete('height');

    const baseParamsString = urlParams.toString();
    
    const widths = [200, 300, 360, 500];
    const srcsetParts = widths.map(width => {
      const params = new URLSearchParams(baseParamsString);
      params.set('width', width);
      params.set('format', 'webp');
      const paramString = params.toString();
      return `${baseUrl}?${paramString} ${width}w`;
    });
    
    const srcParams = new URLSearchParams(baseParamsString);
    srcParams.set('width', '360');
    srcParams.set('format', 'webp');
    const newSrc = `${baseUrl}?${srcParams.toString()}`;
    
    mainImage.src = newSrc;
    mainImage.srcset = srcsetParts.join(', ');
  }
}

function cleanProductUrl(url) {
  if (!url) return url;
  
  const cleanUrl = url.split('?')[0].split('#')[0];
  
  if (!cleanUrl.startsWith('/products/')) {
    return cleanUrl;
  }
  
  return cleanUrl;
}

document.addEventListener('DOMContentLoaded', () => {
  new NewDetailsDrawerController();
});

document.addEventListener('DOMContentLoaded', function() {
  document.addEventListener('click', function(e) {
    const swatch = e.target.closest('.color-swatch');
    if (!swatch || !swatch.hasAttribute('data-product-url')) return;
    
    if (swatch.classList.contains('unavailable')) {
      return;
    }
    
    const swatchContainer = swatch.closest('.product-card-swatches');
    if (swatchContainer) {
      const allSwatches = swatchContainer.querySelectorAll('.color-swatch');
      allSwatches.forEach(s => s.classList.remove('selected'));
      
      swatch.classList.add('selected');
      
      updateProductCarouselMedia(swatchContainer.closest('.product-card'), swatch.dataset.productUrl);
    }
  });
  
  document.addEventListener('click', function(e) {
    const swatch = e.target.closest('.color-swatch');
    if (!swatch || swatch.hasAttribute('data-product-url') || !swatch.hasAttribute('data-option-value')) return;
    
    if (swatch.classList.contains('unavailable')) {
      return;
    }
    
    const swatchContainer = swatch.closest('.product-card-swatches');
    if (swatchContainer) {
      const allSwatches = swatchContainer.querySelectorAll('.color-swatch');
      allSwatches.forEach(s => s.classList.remove('selected'));
      
      swatch.classList.add('selected');
    }
  });
  
  function resetCarouselToFirstSlide(carouselWrapper) {
    if (!carouselWrapper) return;
    
    const productCard = carouselWrapper.closest('.product-card');
    if (!productCard) return;
    
    carouselWrapper.scrollTo({
      left: 0,
      behavior: 'smooth'
    });
    
    const carouselId = carouselWrapper.id;
    const totalMedia = parseInt(carouselWrapper.dataset.totalMedia) || 2;
    
    const scrollThumb = productCard.querySelector(`#scroll-thumb-${carouselId.replace('carousel-', '')}`);
    
    if (scrollThumb) {
      const thumbWidth = 100 / totalMedia;
      scrollThumb.style.width = `${thumbWidth}%`;
      scrollThumb.style.left = '0%';
    }
    
    const prevBtn = productCard.querySelector(`[data-carousel="${carouselId}"][data-direction="prev"]`);
    const nextBtn = productCard.querySelector(`[data-carousel="${carouselId}"][data-direction="next"]`);
    
    if (prevBtn && nextBtn) {
      prevBtn.disabled = true; 
      nextBtn.disabled = totalMedia <= 1;
    }
  }

  function updateProductCarouselMedia(productCard, productUrl) {
    const carouselWrapper = productCard.querySelector('.carousel-wrapper');
    if (!carouselWrapper) return;
    
    const carouselTrack = carouselWrapper.querySelector('.carousel-track');
    if (!carouselTrack) return;
    
    let slides = carouselWrapper.querySelectorAll('.carousel-slide');
    if (slides.length === 0) return;
    
    const cleanUrl = cleanProductUrl(productUrl);
    
    // Store the current product URL in the carousel wrapper
    carouselWrapper.dataset.currentProductUrl = cleanUrl;
    
    slides.forEach(slide => {
      const existingSpinner = slide.querySelector('.carousel-spinner');
      if (existingSpinner) existingSpinner.remove();
      
      const spinnerOverlay = document.createElement('div');
      spinnerOverlay.className = 'carousel-spinner absolute inset-0 flex items-center justify-center bg-white bg-opacity-80 z-10';
      
      const spinnerSVG = `
        <svg width="40" height="40" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" class="animate-spin
        ">
          <path d="M18 9.00551C18 10.2464 17.7643 11.4146 17.2929 12.5102C16.8214 13.6058 16.1804 14.559 15.3698 15.3698C14.559 16.1804 13.6058 16.8214 12.5102 17.2929C11.4146 17.7643 10.2464 18 9.00551 18C7.76633 18 6.59579 17.7634 5.4939 17.2901C4.39217 16.8167 3.43776 16.1764 2.63066 15.3693C1.82357 14.5622 1.18332 13.6087 0.709898 12.5089C0.236632 11.4091 1.37615e-07 10.2395 8.34348e-08 9H1.51531C1.51531 11.0816 2.24235 12.8495 3.69643 14.3036C5.15051 15.7577 6.91837 16.4847 9 16.4847C11.0816 16.4847 12.8495 15.7577 14.3036 14.3036C15.7577 12.8495 16.4847 11.0816 16.4847 9C16.4847 6.91837 15.7577 5.15051 14.3036 3.69643C12.8495 2.24235 11.0816 1.51531 9 1.51531V0C10.2395 -5.41798e-08 11.4091 0.236631 12.5089 0.709897C13.6087 1.18332 14.5622 1.82357 15.3693 2.63066C16.1764 3.43775 16.8167 4.39217 17.2901 5.4939C17.7634 6.59579 18 7.76633 18 9.00551Z" fill="#ffffff"></path>
          <path d="M8.99449 18C7.75362 18 6.58538 17.7643 5.48977 17.2929C4.39416 16.8214 3.44143 16.1799 2.63066 15.3693C1.82005 14.5586 1.17857 13.6058 0.707143 12.5102C0.235714 11.4146 0 10.2464 0 9.00551C0 7.76633 0.236633 6.59579 0.709898 5.4939C1.18332 4.39217 1.82357 3.43776 2.63066 2.63066C3.43775 1.82357 4.39125 1.18332 5.49115 0.709898C6.59089 0.236633 7.76051 0 9 0V1.51531C6.91837 1.51531 5.15051 2.24235 3.69643 3.69643C2.24235 5.15051 1.51531 6.91837 1.51531 9C1.51531 11.0816 2.24235 12.8495 3.69643 14.3036C5.15051 15.7577 6.91837 16.4847 9 16.4847C11.0816 16.4847 12.8495 15.7577 14.3036 14.3036C15.7577 12.8495 16.4847 11.0816 16.4847 9H18C18 10.2395 17.7634 11.4091 17.2901 12.5089C16.8167 13.6087 16.1769 14.5627 15.3698 15.3698C14.5627 16.1769 13.6078 16.8167 12.5061 17.2901C11.4042 17.7634 10.2337 18 8.99449 18Z" fill="#E40001"></path>
        </svg>
      `;
      
      spinnerOverlay.innerHTML = spinnerSVG;
      slide.style.position = 'relative';
      slide.appendChild(spinnerOverlay);
      
      const media = slide.querySelector('img, video');
      if (media) {
        media.style.opacity = '0.3';
        media.style.transition = 'opacity 0.3s ease';
      }
    });
    
    fetch(cleanUrl + '.js')
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(productData => {
        const maxMedia = 7;
        const limitedMedia = productData.media.slice(0, maxMedia);
        
        carouselWrapper.dataset.totalMedia = limitedMedia.length;
        
        const scrollThumb = productCard.querySelector('.product-card__scroll-bar-thumb');
        if (scrollThumb) {
          scrollThumb.dataset.totalSlides = limitedMedia.length;
          scrollThumb.style.width = `${100 / limitedMedia.length}%`;
        }
        
        slides = carouselWrapper.querySelectorAll('.carousel-slide');
        const currentSlideCount = slides.length;
        
        if (limitedMedia.length > currentSlideCount) {
          for (let i = currentSlideCount; i < limitedMedia.length; i++) {
            const newSlide = document.createElement('div');
            newSlide.className = 'carousel-slide flex-shrink-0 w-full';
            newSlide.dataset.mediaIndex = i + 1;
            newSlide.style.display = 'none';
            
            const link = document.createElement('a');
            link.href = productData.url;
            link.className = 'block w-full bg-highlight-neutral-97 px-0 md:px-2xl-size py-14 md:py-17';
            link.setAttribute('aria-label', productData.title);
            
            newSlide.appendChild(link);
            carouselTrack.appendChild(newSlide);
          }
          
          slides = carouselWrapper.querySelectorAll('.carousel-slide');
        }
        
        limitedMedia.forEach((media, index) => {
          const slide = slides[index];
          if (slide) {
            slide.dataset.mediaType = media.media_type;
            slide.dataset.mediaSrc = media.media_type === 'image' ? 
              media.src || media : 
              media.sources?.[0]?.url || media.src;
            slide.dataset.mediaAlt = media.alt || productData.title;
            slide.dataset.mediaPreview = media.media_type === 'video' ? 
              media.preview_image?.src || media.preview_image : 
              '';
            slide.dataset.mediaIndex = index + 1;
          }
        });
        
         slides.forEach((slide, index) => {
           const mediaToUpdate = slide.querySelector('img, video');
           const spinnerOverlay = slide.querySelector('.carousel-spinner');
           
           if (index < limitedMedia.length) {
             const newMedia = limitedMedia[index];
             const parentLink = slide.querySelector('a');
             
             if (!parentLink) return;
             
             if (newMedia.media_type === 'image') {
               const newImage = document.createElement('img');
               newImage.src = slide.dataset.mediaSrc;
               newImage.alt = slide.dataset.mediaAlt;
               newImage.className = 'aspect-square object-cover mix-blend-multiply block w-full h-auto';
               newImage.width = 300;
               newImage.height = 'auto';
               newImage.loading = index === 0 ? 'eager' : 'lazy';
               newImage.style.opacity = '1';
               
               newImage.onload = () => {
                 newImage.style.opacity = '1';
               };
               
               parentLink.innerHTML = '';
               parentLink.appendChild(newImage);
               parentLink.href = productData.url;
               
               if (spinnerOverlay) spinnerOverlay.remove();
             } else if (newMedia.media_type === 'video') {
               const newVideo = document.createElement('video');
               
               newVideo.setAttribute('playsinline', 'true');
               newVideo.setAttribute('loop', 'loop');
               newVideo.setAttribute('autoplay', 'autoplay');
               newVideo.setAttribute('muted', 'muted');
               newVideo.setAttribute('class', 'aspect-square object-cover w-full h-auto');
               newVideo.setAttribute('loading', 'lazy');
               newVideo.setAttribute('preload', 'metadata');
               newVideo.setAttribute('aria-label', slide.dataset.mediaAlt);
               
               const sourceElement = document.createElement('source');
               sourceElement.setAttribute('src', slide.dataset.mediaSrc);
               sourceElement.setAttribute('type', 'video/mp4');
               
               newVideo.appendChild(sourceElement);
               
               if (slide.dataset.mediaPreview) {
                 const fallbackImg = document.createElement('img');
                 fallbackImg.setAttribute('src', slide.dataset.mediaPreview);
                 newVideo.appendChild(fallbackImg);
               }
               
               parentLink.innerHTML = '';
               parentLink.appendChild(newVideo);
               parentLink.href = productData.url;
               
               if (spinnerOverlay) spinnerOverlay.remove();
               newVideo.style.opacity = '1';
             }
             
             slide.style.display = 'flex';
             slide.style.opacity = '1';
             
           } else {
             slide.style.display = 'none';
             slide.style.opacity = '0';
             if (spinnerOverlay) spinnerOverlay.remove();
           }
         });
        
        resetCarouselToFirstSlide(carouselWrapper);
        
        const carouselButtons = productCard.querySelectorAll('[data-carousel]');
        carouselButtons.forEach(btn => {
          const parentLink = btn.closest('.product-card');
          const titleLink = parentLink.querySelector('a[href*="/products/"]:last-of-type');
          if (titleLink) {
            titleLink.href = cleanUrl;
          }
        });
        
      })
      .catch(error => {
        console.error('Error loading product data:', error);
        
        slides.forEach(slide => {
          const spinnerOverlay = slide.querySelector('.carousel-spinner');
          if (spinnerOverlay) spinnerOverlay.remove();
          
          const mediaToUpdate = slide.querySelector('img, video');
          if (mediaToUpdate) {
            mediaToUpdate.style.opacity = '1';
          }
        });
        
        if (error.message.includes('Unexpected token')) {
          console.warn('Product URL returned HTML instead of JSON. This might be a 404 or invalid product URL:', cleanUrl);
        } else if (error.message.includes('HTTP error')) {
          console.warn('HTTP error when fetching product data:', cleanUrl);
        }
      });
  }
});

document.addEventListener('DOMContentLoaded', function() {
  initializeSwatchExpansion();
  
  $(document).on('fineshedLoadPLP', function() {
    setTimeout(() => {
      if (window.reinitializeSwatchExpansion) {
        window.reinitializeSwatchExpansion();
      }
      if (window.reinitializeCarousels) {
        window.reinitializeCarousels();
      }
    }, 100);
  });
  
  const visibleCarousels = document.querySelectorAll('.grid__item:not(.hidden) .carousel-wrapper');

  visibleCarousels.forEach((carousel, index) => {
    initializeCarousel(carousel);
    carousel.setAttribute('data-carousel-initialized', 'true');
  });
});

function initializeSwatchExpansion() {
  const swatchContainers = document.querySelectorAll('[data-swatches-container]');
  
  swatchContainers.forEach(container => {
    setupSwatchExpansion(container);
  });
}

window.reinitializeSwatchExpansion = function() {
  const swatchContainers = document.querySelectorAll('[data-swatches-container]');
  
  swatchContainers.forEach(container => {
    if (!container.hasAttribute('data-swatch-initialized')) {
      setupSwatchExpansion(container);
      container.setAttribute('data-swatch-initialized', 'true');
    }
  });
};

window.reinitializeCarousels = function() {
  const visibleCarousels = document.querySelectorAll('.grid__item:not(.hidden) .carousel-wrapper');
  
  visibleCarousels.forEach(carousel => {
    if (!carousel.hasAttribute('data-carousel-initialized')) {
      initializeCarousel(carousel);
      carousel.setAttribute('data-carousel-initialized', 'true');
    }
  });
};

function initializeCarousel(carousel) {
  const carouselId = carousel.id;
  
  const productCard = carousel.closest('.product-card');
  if (!productCard) {
    console.warn(`Skipping carousel ${carouselId} - product card not found`);
    return;
  }
  
  const prevBtn = productCard.querySelector(`[data-carousel="${carouselId}"][data-direction="prev"]`);
  const nextBtn = productCard.querySelector(`[data-carousel="${carouselId}"][data-direction="next"]`);
  const scrollThumb = productCard.querySelector(`#scroll-thumb-${carouselId.replace('carousel-', '')}`);
      
  if (!carousel || !prevBtn || !nextBtn) {
    console.warn(`Skipping carousel ${carouselId} - missing elements`);
    return;
  }
  
  const totalMedia = parseInt(carousel.dataset.totalMedia) || 2;
  let currentSlide = 0;
  
  function updateScrollThumb() {
    if (scrollThumb) {
      // Get current totalMedia from carousel dataset (updated when product changes)
      const currentTotalMedia = parseInt(carousel.dataset.totalMedia) || totalMedia;
      const thumbWidth = 100 / currentTotalMedia; 
      const thumbLeft = (currentSlide * thumbWidth);
      scrollThumb.style.width = `${thumbWidth}%`;
      scrollThumb.style.left = `${thumbLeft}%`;
    }
  }
  
  function updateNavButtons() {
    const currentPrevBtn = productCard.querySelector(`[data-carousel="${carouselId}"][data-direction="prev"]`);
    const currentNextBtn = productCard.querySelector(`[data-carousel="${carouselId}"][data-direction="next"]`);
    
    const currentTotalMedia = parseInt(carousel.dataset.totalMedia) || totalMedia;
    
    if (currentPrevBtn) currentPrevBtn.disabled = currentSlide === 0;
    if (currentNextBtn) currentNextBtn.disabled = currentSlide === currentTotalMedia - 1;
  }
  
  function loadSlideContent(slideElement) {
    // Skip if already has content
    if (slideElement.querySelector('img, video')) {
      // Just ensure it's visible
      if (slideElement.style.display === 'none') {
        slideElement.style.display = 'flex';
      }
      return;
    }
    
    const mediaType = slideElement.dataset.mediaType;
    const mediaSrc = slideElement.dataset.mediaSrc;
    const mediaAlt = slideElement.dataset.mediaAlt;
    const mediaPreview = slideElement.dataset.mediaPreview;
    const parentLink = slideElement.querySelector('a');
    
    if (!parentLink) return;
    
    slideElement.style.display = 'none';
    
    if (mediaType === 'image') {
      const img = document.createElement('img');
      img.src = mediaSrc;
      img.alt = mediaAlt;
      img.className = 'aspect-square object-cover mix-blend-multiply block w-full h-auto';
      img.width = 300;
      img.height = 'auto';
      img.loading = 'lazy';
      
      img.onload = () => {
        slideElement.style.display = 'flex';
      };
      
      img.onerror = () => {
        slideElement.style.display = 'flex';
      };
      
      parentLink.innerHTML = '';
      parentLink.appendChild(img);
      
      if (img.complete) {
        slideElement.style.display = 'flex';
      }
      
    } else if (mediaType === 'video') {
      const video = document.createElement('video');
      video.setAttribute('playsinline', 'true');
      video.setAttribute('loop', 'loop');
      video.setAttribute('autoplay', 'autoplay');
      video.setAttribute('muted', 'muted');
      video.setAttribute('class', 'aspect-square object-cover w-full h-auto');
      video.setAttribute('loading', 'lazy');
      video.setAttribute('preload', 'metadata');
      video.setAttribute('aria-label', mediaAlt);
      
      const source = document.createElement('source');
      source.setAttribute('src', mediaSrc);
      source.setAttribute('type', 'video/mp4');
      video.appendChild(source);
      
      if (mediaPreview) {
        const fallbackImg = document.createElement('img');
        fallbackImg.setAttribute('src', mediaPreview);
        video.appendChild(fallbackImg);
      }
      
      parentLink.innerHTML = '';
      parentLink.appendChild(video);
      
      slideElement.style.display = 'flex';
    }
  }
  
  function preloadNextSlide() {
    const currentTotalMedia = parseInt(carousel.dataset.totalMedia) || totalMedia;
    const nextSlideIndex = currentSlide + 1;
    if (nextSlideIndex < currentTotalMedia) {
      const nextSlide = carousel.querySelector(`[data-media-index="${nextSlideIndex + 1}"]`);
      if (nextSlide && !nextSlide.querySelector('img, video')) {
        // Preload the next slide
        const mediaSrc = nextSlide.dataset.mediaSrc;
        const mediaType = nextSlide.dataset.mediaType;
        
        if (mediaType === 'image') {
          const preloadImg = new Image();
          preloadImg.src = mediaSrc;
        } else if (mediaType === 'video') {
          const preloadVideo = document.createElement('video');
          preloadVideo.preload = 'metadata';
          preloadVideo.src = mediaSrc;
        }
      }
    }
  }
  
   function goToSlide(slideIndex) {
     const currentTotalMedia = parseInt(carousel.dataset.totalMedia) || totalMedia;
     currentSlide = Math.max(0, Math.min(slideIndex, currentTotalMedia - 1));
     
     const currentSlideElement = carousel.querySelector(`[data-media-index="${currentSlide + 1}"]`) || 
                                 carousel.querySelectorAll('.carousel-slide')[currentSlide];
     if (currentSlideElement) {
       loadSlideContent(currentSlideElement);
     }
     
     updateProductLinks();
     
     preloadNextSlide();
     
     const slideWidth = carousel.offsetWidth;
     carousel.scrollTo({
       left: currentSlide * slideWidth,
       behavior: 'smooth'
     });
     updateScrollThumb();
     updateNavButtons();
   }
   
   function updateProductLinks() {
     const currentProductUrl = carousel.dataset.currentProductUrl;
     if (!currentProductUrl) return;
     
     // Update all links in the product card
     const productCard = carousel.closest('.product-card');
     if (productCard) {
       const allLinks = productCard.querySelectorAll('a[href*="/products/"]');
       allLinks.forEach(link => {
         link.href = currentProductUrl;
       });
     }
   }
  
  prevBtn.replaceWith(prevBtn.cloneNode(true));
  nextBtn.replaceWith(nextBtn.cloneNode(true));
  
  const newPrevBtn = productCard.querySelector(`[data-carousel="${carouselId}"][data-direction="prev"]`);
  const newNextBtn = productCard.querySelector(`[data-carousel="${carouselId}"][data-direction="next"]`);
  
  if (!newPrevBtn || !newNextBtn) {
    console.warn(`Skipping carousel ${carouselId} - buttons not found after cloning`);
    return;
  }
  
  newPrevBtn.disabled = true; 
  newNextBtn.disabled = (parseInt(carousel.dataset.totalMedia) || totalMedia) <= 1;
  
  newPrevBtn.addEventListener('click', () => {
    if (currentSlide > 0) {
      goToSlide(currentSlide - 1);
    }
  });
  
  newNextBtn.addEventListener('click', () => {
    const currentTotalMedia = parseInt(carousel.dataset.totalMedia) || totalMedia;
    if (currentSlide < currentTotalMedia - 1) {
      goToSlide(currentSlide + 1);
    }
  });
  
   carousel.addEventListener('scroll', () => {
     const slideWidth = carousel.offsetWidth;
     const scrollLeft = carousel.scrollLeft;
     const newSlide = Math.round(scrollLeft / slideWidth);
     const currentTotalMedia = parseInt(carousel.dataset.totalMedia) || totalMedia;
     
     if (newSlide !== currentSlide && newSlide < currentTotalMedia) {
       currentSlide = newSlide;
       
       const allSlides = carousel.querySelectorAll('.carousel-slide');
       allSlides.forEach((slide, idx) => {
         if (idx >= currentTotalMedia) {
           slide.style.display = 'none';
         }
       });
       
       const currentSlideElement = carousel.querySelector(`[data-media-index="${currentSlide + 1}"]`) || 
                                   carousel.querySelectorAll('.carousel-slide')[currentSlide];
       if (currentSlideElement) {
         loadSlideContent(currentSlideElement);
       }
       
       updateProductLinks();
       
       preloadNextSlide();
       
       updateScrollThumb();
       updateNavButtons();
     }
   });
  
  const firstSlide = carousel.querySelector('.carousel-slide');
  if (firstSlide) {
    const firstLink = firstSlide.querySelector('a[href*="/products/"]');
    if (firstLink && !carousel.dataset.currentProductUrl) {
      carousel.dataset.currentProductUrl = firstLink.href;
    }
  }
  
  updateScrollThumb();
  updateNavButtons();
}

function setupSwatchExpansion(container) {
  const expandBtn = container.querySelector('[data-expand-btn]');
  
  if (!expandBtn) return;
  
  updateSwatchVisibility(container);
  
  if (!expandBtn.hasAttribute('data-listener-added')) {
    expandBtn.addEventListener('click', function() {
      toggleSwatchExpansion(container, this);
    });
    expandBtn.setAttribute('data-listener-added', 'true');
  }
  
  if (!container.hasAttribute('data-resize-listener-added')) {
    let resizeTimeout;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        updateSwatchVisibility(container);
      }, 150);
    });
    container.setAttribute('data-resize-listener-added', 'true');
  }
  
  container.setAttribute('data-swatch-initialized', 'true');
}

function updateSwatchVisibility(container) {
  const allSwatches = container.querySelectorAll('.color-swatch:not(.expand-btn)');
  const expandBtn = container.querySelector('[data-expand-btn]');
  
  if (!expandBtn) return;
  
  const width = window.innerWidth;
  let maxVisible;
  
  if (width >= 1280) {
    maxVisible = 5; 
  } else if (width >= 1024) {
    maxVisible = 4; 
  } else {
    maxVisible = 3; 
  }
  
  if (allSwatches.length > maxVisible) {
    expandBtn.classList.remove('hidden');
  } else {
    expandBtn.classList.add('hidden');
  }
}

function getVisibleCount() {
  const width = window.innerWidth;
  
  if (width >= 1280) return 5;
  if (width >= 1024) return 4;
  return 3;
}

function toggleSwatchExpansion(container, expandBtn) {
  const expandIcon = expandBtn.querySelector('.expand-icon');
  
  if (expandBtn.classList.contains('expanded')) {
    expandBtn.classList.remove('expanded');
    expandIcon.textContent = '+';
    container.classList.remove('expanded');
  } else {
    expandBtn.classList.add('expanded');
    expandIcon.textContent = '-';
    container.classList.add('expanded');
  }
}